import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    title: "添加关联业务",
    width: "620px",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.dialogVisible = $event)
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
      onClick: $setup.close
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.confirmHandler
    }, {
      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("确 定", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      size: "small",
      inline: true,
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "form",
      class: "demo-form-inline"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "业务编码",
            prop: "offerId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入业务编码",
              modelValue: _ctx.formData.offerId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.formData.offerId = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "业务名称",
            prop: "offerName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入业务名称",
              modelValue: _ctx.formData.offerName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.formData.offerName = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "业务链接",
            class: "length-input"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入业务链接",
              modelValue: _ctx.formData.busiLink,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.formData.busiLink = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "业务有效期",
        prop: "dateRange"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: _ctx.formData.dateRange,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.formData.dateRange = $event),
          type: "daterange",
          "range-separator": "至",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          onChange: $setup.dateRangeChange,
          format: "YYYY-MM-DD HH:mm:ss",
          "default-time": _ctx.defaultTime
        }, null, 8, ["modelValue", "onChange", "default-time"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"]);
}